import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/relatorios/controle-saldo'

class ControleSaldosApiClient {
	async buscarAtas({ paginacao, numeroAta }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/atas`,
			filters: { numeroAta },
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}

	async buscarOrgaos(idAta) {
		return await axios.get(`${URL_PATH}/orgaos/${idAta}`)
	}

	async gerarRelatorioControleSaldo(objParam) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/gerar`,
			filters: objParam,
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}
}

export default new ControleSaldosApiClient()
